"use client";

import type { FC, Ref } from "react";
import {
  NeighbourhoodAnalysis,
  type NeighbourhoodAnalysisProps,
} from "@huub-web/shared";

import { useTemplates } from "../../hooks";

export interface AnalysisNeighbourhoodTemplateProps {
  address: NeighbourhoodAnalysisProps["address"];
  center: NeighbourhoodAnalysisProps["center"];
  geoJSON?: NeighbourhoodAnalysisProps["geoJSON"];
  name: NeighbourhoodAnalysisProps["name"];
  description: NeighbourhoodAnalysisProps["description"];
  amenities: NeighbourhoodAnalysisProps["amenities"];
}

/**
 * @deprecated
 */
export const AnalysisNeighbourhoodTemplate: FC<
  AnalysisNeighbourhoodTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ address, center, geoJSON, name, description, amenities, ref }) => {
  const { env } = useTemplates();

  return (
    <NeighbourhoodAnalysis
      ref={ref}
      address={address}
      center={center}
      geoJSON={geoJSON}
      accessToken={env.mapBoxToken}
      name={name}
      description={description}
      amenities={amenities}
      container="default"
    />
  );
};
